module.exports = __webpack_public_path__ + "static/img/danger.6bfc3127.svg";